module.exports = __webpack_public_path__ + "img/ecommerce-active.82e71dd5.svg";